import React from 'react';
import { Card } from './ui/Card';
import { CheckCircle2Icon, BookOpenIcon, UsersIcon, SparklesIcon } from 'lucide-react';
export function ProductBreakdown() {
  return <section className="py-20 bg-gray-50" id="whats-included" data-id="element-109">
      <div className="container mx-auto px-4" data-id="element-110">
        <div className="text-center mb-16" data-id="element-111">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-4" data-id="element-112">
            What's Inside the <span className="text-red-700" data-id="element-113">Toolkit</span>?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-114">
            Everything you need for your classes, organized by level and
            learning objective.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-115">
          {/* Elementary */}
          <Card className="flex flex-col h-full hover:shadow-2xl transition-shadow duration-300 border-t-4 border-t-amber-500" data-id="element-116">
            <div className="h-48 overflow-hidden relative group" data-id="element-117">
              <img src="https://cdn.magicpatterns.com/uploads/3k1Tnx8iT5wgA1uahwmTd5/ChatGPT_Image_2_mar_2026,_12_28_39_p.m..png" alt="Elementary Drama" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-118" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-6" data-id="element-119">
                <h3 className="text-2xl font-bold text-white flex items-center gap-2" data-id="element-120">
                  <BookOpenIcon className="w-6 h-6 text-amber-400" data-id="element-121" />
                  Elementary Level
                </h3>
              </div>
            </div>
            <div className="p-8 flex-1 flex flex-col" data-id="element-122">
              <p className="text-gray-600 mb-6" data-id="element-123">
                Playful, structured material to introduce young students to the
                world of drama and performance.
              </p>
              <ul className="space-y-3 mb-8 flex-1" data-id="element-124">
                <li className="flex items-start gap-3" data-id="element-125">
                  <CheckCircle2Icon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-126" />
                  <span className="text-gray-700" data-id="element-127">
                    Detailed weekly lesson plans
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-128">
                  <CheckCircle2Icon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-129" />
                  <span className="text-gray-700" data-id="element-130">
                    Drama games and warm-up activities
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-131">
                  <CheckCircle2Icon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-132" />
                  <span className="text-gray-700" data-id="element-133">
                    Short performance projects
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-134">
                  <CheckCircle2Icon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-135" />
                  <span className="text-gray-700" data-id="element-136">
                    Age-appropriate assessments
                  </span>
                </li>
              </ul>
            </div>
          </Card>

          {/* Middle & High School */}
          <Card className="flex flex-col h-full hover:shadow-2xl transition-shadow duration-300 border-t-4 border-t-red-600 transform md:-translate-y-4" data-id="element-137">
            <div className="h-48 overflow-hidden relative group" data-id="element-138">
              <img src="https://cdn.magicpatterns.com/uploads/cJppDjTVTbDXaPnV82u9HK/ChatGPT_Image_2_mar_2026,_12_19_23_p.m..png" alt="Middle & High School Drama" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-139" />
              <div className="absolute top-4 right-4 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg" data-id="element-140">
                MOST POPULAR
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-6" data-id="element-141">
                <h3 className="text-2xl font-bold text-white flex items-center gap-2" data-id="element-142">
                  <UsersIcon className="w-6 h-6 text-red-400" data-id="element-143" />
                  Middle & High School
                </h3>
              </div>
            </div>
            <div className="p-8 flex-1 flex flex-col bg-white" data-id="element-144">
              <p className="text-gray-600 mb-6" data-id="element-145">
                Creative and technical challenges for teens, focused on
                self-expression and full production.
              </p>
              <ul className="space-y-3 mb-8 flex-1" data-id="element-146">
                <li className="flex items-start gap-3" data-id="element-147">
                  <CheckCircle2Icon className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-148" />
                  <span className="text-gray-700" data-id="element-149">
                    Complete year-long curriculum plans
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-150">
                  <CheckCircle2Icon className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-151" />
                  <span className="text-gray-700" data-id="element-152">
                    Advanced improvisation techniques
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-153">
                  <CheckCircle2Icon className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-154" />
                  <span className="text-gray-700" data-id="element-155">
                    Character development guides
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-156">
                  <CheckCircle2Icon className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-157" />
                  <span className="text-gray-700" data-id="element-158">
                    Full production projects
                  </span>
                </li>
              </ul>
            </div>
          </Card>

          {/* Bonus Resources */}
          <Card className="flex flex-col h-full hover:shadow-2xl transition-shadow duration-300 border-t-4 border-t-purple-600" data-id="element-159">
            <div className="h-48 overflow-hidden relative group" data-id="element-160">
              <img src="https://cdn.magicpatterns.com/uploads/pE8HH7HTpL3xCiR4KqNRm4/ChatGPT_Image_2_mar_2026,_12_26_30_p.m..png" alt="Bonus Resources" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-161" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-6" data-id="element-162">
                <h3 className="text-2xl font-bold text-white flex items-center gap-2" data-id="element-163">
                  <SparklesIcon className="w-6 h-6 text-purple-400" data-id="element-164" />
                  Bonus Resources
                </h3>
              </div>
            </div>
            <div className="p-8 flex-1 flex flex-col" data-id="element-165">
              <p className="text-gray-600 mb-6" data-id="element-166">
                Extra tools to enrich your classes and handle any unexpected
                situation with confidence.
              </p>
              <ul className="space-y-3 mb-8 flex-1" data-id="element-167">
                <li className="flex items-start gap-3" data-id="element-168">
                  <CheckCircle2Icon className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" data-id="element-169" />
                  <span className="text-gray-700" data-id="element-170">
                    100+ group warm-up activities
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-171">
                  <CheckCircle2Icon className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" data-id="element-172" />
                  <span className="text-gray-700" data-id="element-173">
                    School showcase and talent show ideas
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-174">
                  <CheckCircle2Icon className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" data-id="element-175" />
                  <span className="text-gray-700" data-id="element-176">
                    100% editable script templates
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-177">
                  <CheckCircle2Icon className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" data-id="element-178" />
                  <span className="text-gray-700" data-id="element-179">
                    Student progress tracking sheets
                  </span>
                </li>
              </ul>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}